<template>
<div>
    <h1 class="mb-4 text-gray-500">Shesfreaky Downloader</h1>

    <client-only>
        <template #fallback>
            <el-card shadow="never" :body-style="{padding: '0'}" class="mb-4">
                <div style="height: 100px" class="flex items-center justify-center">
                    <ElIconLoading :width="20" class="mr-2"/>
                    Loading the app
                </div>
            </el-card>
        </template>
        <downloader></downloader>
    </client-only>
    <el-card shadow="never" class="mb-4" :body-style="{ padding: '20px' }">
        <h2 class="text-2xl mb-4">
            Demo video
        </h2>
        <div class="mb-4"> Learn how to get started with shesfreaky downloader by watching the demo video </div>
        <el-button type="info" size="large" :icon="ElIconVideoPlay" @click="showDemoVideo = true" v-if="!showDemoVideo">Watch video</el-button>

        <video controls autoplay="false" v-show="showDemoVideo">
            <source src="https://anyloader.com/onlyfans_downloader_demo.mp4" type="video/mp4">
            Your browser does not support the video tag.
        </video>
    </el-card>

    <shesfreaky-faq></shesfreaky-faq>
</div>
</template>
<script>
export default {
    created() {
        const siteUrl = useRuntimeConfig().public.siteUrl
        const faqStructuredData = {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
                {
                    '@type': 'Question',
                    name: 'What is Shesfreaky Downloader?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Shesfreaky Downloader is a free Chrome extension that lets you download videos from Shesfreaky for offline viewing. Save your favorite videos directly to your device in original quality.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'How does Shesfreaky Downloader work?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'The downloader works through a Chrome extension that extracts video URLs from Shesfreaky pages. Paste the video URL into the downloader, and it will find and prepare the video for download.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'Is Shesfreaky Downloader safe to use?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Yes, Shesfreaky Downloader is safe to use. It runs entirely in your Chrome browser as an extension, without requiring any desktop software installation that could harm your computer.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'Can I download videos on mobile devices?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Shesfreaky Downloader is designed for desktop Chrome browsers. For mobile downloads, you would need to use the desktop Chrome browser or transfer downloaded files from your computer to your mobile device.'
                    }
                }
            ]
        }

        useHead({
            title: 'Free Shesfreaky Downloader - Download Videos from Shesfreaky',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Download videos from Shesfreaky for free using our Chrome extension. Save videos in original quality for offline viewing. Safe and easy to use.',
                },
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: 'shesfreaky downloader, download shesfreaky videos, shesfreaky video downloader, free shesfreaky downloader, shesfreaky chrome extension'
                }
            ],
            link: [
                {rel: 'canonical', href: siteUrl + '/shesfreaky-downloader'}
            ],
            script: [
                {
                    type: 'application/ld+json',
                    children: JSON.stringify(faqStructuredData)
                }
            ]
        })
    },
    data () {
        return {
            showDemoVideo: false
        }
    }
}
</script>